import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'apps/shared/scripts/components';

import { buttonClassName } from './styles';

interface Props {
  to?: string | null;
}

const BackButton = ({ to }: Props) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    if (to) {
      navigate(to, { replace: false });
    } else {
      navigate(-1);
    }
  }, [navigate, to]);

  return (
    <Button
      className={buttonClassName}
      faIcon={faArrowLeftLong}
      onClick={onClick}
      subtle
    />
  );
};

BackButton.displayName = 'BackButton';

export default BackButton;
